import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.77 6.1652L2 7.94521L11.9 17.8352L21.8 7.9352L20.03 6.1652L11.9 14.2952L3.77 6.1652Z"
      fill="currentColor"
    />
  </svg>
}

export default SvgComponent;
